import React, {useEffect} from "react";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../../../redux/store";

import {
    Ticket,
    Commento,
    saveCommento,
} from "../../ticketingSlice";

import {useForm, SubmitHandler, } from "react-hook-form";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import {Button} from "@mui/material";
import {Alert} from "@mui/material";
import SendIcon from '@mui/icons-material/Send';
import {UtenteLogged} from "../../../authentication/authenticationSlice";
import {utenteFullName} from "../../../authentication/UtenteFullName";

interface CommentoAddFormProps {
    ticket: Ticket;
    consentiModifica: boolean;
}

const CommentoAddForm = ({
                             ticket,
                             consentiModifica = false,
                         }: CommentoAddFormProps) => {
    const {
        handleSubmit,
        register,
        formState: {errors, isDirty},
        setValue,
        setError,
        clearErrors,
        reset,
    } = useForm<Commento>();

    const utenteLogged = useSelector<RootState, UtenteLogged>((state) => state.authentication.utenteLogged);

    const commento: Commento = {
        ticket: ticket.id || 0,
        testo: "",
        autore_id: utenteLogged?.id,
        autore_descrizione: utenteFullName(utenteLogged),
        created_at: new Date(),
    }

    const listaCampi = Object.keys(commento) as Array<keyof Commento>;

    const dispatch = useAppDispatch();


    useEffect(() => {
        reset(commento);
    }, []);

    useEffect(() => {
        clearErrors();
        listaCampi.forEach((field) => {
            commento?.errorsStack?.fieldsErrors &&
            commento.errorsStack.fieldsErrors[field] &&
            setError(field, {
                type: "server",
                message: commento.errorsStack.fieldsErrors[field].toString(),
            });
        });
    }, [
        commento?.errorsStack?.fieldsErrors,
        // cliente.allevamento_pack?.errorsStack?.fieldsErrors,
    ]);

    const handlerSaveCommento = (commento: Commento) => {
        consentiModifica && dispatch(saveCommento({ticket:ticket, commentoToAdd: commento}));
        setValue("testo", "")
    };



    const onSubmit: SubmitHandler<Commento> = (commento) => {
        handlerSaveCommento(commento);
    };


    return (
        <Box sx={{mb: 1}}>
            <form onSubmit={handleSubmit(onSubmit)}>
                {commento?.errorsStack?.fieldsErrors?.non_field_errors && (
                    <Alert severity="error">
                        {commento?.errorsStack?.fieldsErrors?.non_field_errors.toString()}
                    </Alert>
                )}

                <Grid
                    container
                    spacing={{xs: 0.5, md: 1, lg: 2}}
                    sx={{mb: 1}}
                >
                    <Grid size={{ xs:9, sm:10, md:11, lg:11 }}>
                        <TextField
                            // label="descrizione"
                            // disabled={!iterConnessione.codice_pod}
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            // multiline={true}
                            // rows={1}
                            {...register("testo")}
                            // onBlur={handlerDetailChangeSubmit}
                            disabled={!consentiModifica}
                            error={!!errors?.testo}
                            helperText={errors?.testo?.message}
                            autoComplete={"off"}
                            sx={{
                                width: "100%",
                            }}
                            size="small"
                            fullWidth
                        />
                    </Grid>

                    <Grid size={{ xs:3, sm:2, md:1, lg:1 }}>
                        <Button
                            type="submit"
                            disabled={!consentiModifica || !isDirty}
                            // fullWidth
                            size="small"
                            variant="outlined"
                            color="primary"
                            // sx={{ margin: (theme) => theme.spacing(3, 0, 2) }}
                        >
                            <SendIcon />
                        </Button>
                    </Grid>

                </Grid>

            </form>
        </Box>
    );
};

export default CommentoAddForm;
